<template>
  <div class="loadingBox" v-show="isLoading">
    <div class="maxLoading" :style="{backgroundColor:backgroundColor}">
      <div class="loading_bg">
        <div class="loader-inner pacman">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default{
  props: {
    isLoading:[Boolean]
    ,
    backgroundColor:{
      type:String
      ,default:"rgba(0, 0, 0, .2)"
    }
  }
  ,data(){
    return {
      images:{
      }
    }
  }
  ,methods:{

  }
	,components:{

	}
  ,computed:{

  }
}
</script>

<style scoped>

</style>

<style>
.loadingBox > .maxLoading{
  position: absolute;
  top:0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #959697;
  cursor: progress;
}
.maxLoading .loading_bg{
	position:absolute;
	top:20%;
	left:50%;
  padding: 20px 10px;
  width: 150px;
	height: 50px;
	border-radius:10px;
  margin-left:-300px;
  -webkit-animation: pacman-box 4s 0.1s infinite linear;
            animation: pacman-box 4s 0.1s infinite linear;
	/*background-color: rgba(73,91,111,0.4);*/
}

@-webkit-keyframes rotate_pacman_half_up {
  0% {
    -webkit-transform: rotate(270deg);
            transform: rotate(270deg); }

  50% {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg); }

  100% {
    -webkit-transform: rotate(270deg);
            transform: rotate(270deg); } }

@keyframes rotate_pacman_half_up {
  0% {
    -webkit-transform: rotate(270deg);
            transform: rotate(270deg); }

  50% {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg); }

  100% {
    -webkit-transform: rotate(270deg);
            transform: rotate(270deg); } }

@-webkit-keyframes rotate_pacman_half_down {
  0% {
    -webkit-transform: rotate(90deg);
            transform: rotate(90deg); }

  50% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg); }

  100% {
    -webkit-transform: rotate(90deg);
            transform: rotate(90deg); } }

@keyframes rotate_pacman_half_down {
  0% {
    -webkit-transform: rotate(90deg);
            transform: rotate(90deg); }

  50% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg); }

  100% {
    -webkit-transform: rotate(90deg);
            transform: rotate(90deg); } }

@-webkit-keyframes pacman-balls {
  75% {
    opacity: 0.7; }

  100% {
    -webkit-transform: translate(-100px, -6.25px);
            transform: translate(-100px, -6.25px); } }

@keyframes pacman-balls {
  75% {
    opacity: 0.7; }

  100% {
    -webkit-transform: translate(-100px, -6.25px);
            transform: translate(-100px, -6.25px); } }

@-webkit-keyframes pacman-box {
  0% {
    opacity: 0.5; }

  20% {
    opacity: 1; }

  80% {
    opacity: 1; }

  100% {
    -webkit-transform: translate(500px, -6.25px);
            transform: translate(500px, -6.25px); } }

@keyframes pacman-box {
  0% {
    opacity: 1; }

  20% {
    opacity: 1; }

  80% {
    opacity: 1; }

  100% {
    -webkit-transform: translate(500px, -6.25px);
            transform: translate(500px, -6.25px); } }

.pacman {
  position: relative; }
  .pacman > div:nth-child(2) {
    -webkit-animation: pacman-balls 1s 0s infinite linear;
            animation: pacman-balls 1s 0s infinite linear; }
  .pacman > div:nth-child(3) {
    -webkit-animation: pacman-balls 1s 0.33s infinite linear;
            animation: pacman-balls 1s 0.33s infinite linear; }
  .pacman > div:nth-child(4) {
    -webkit-animation: pacman-balls 1s 0.66s infinite linear;
            animation: pacman-balls 1s 0.66s infinite linear; }
  .pacman > div:nth-child(5) {
    -webkit-animation: pacman-balls 1s 0.99s infinite linear;
            animation: pacman-balls 1s 0.99s infinite linear; }
  .pacman > div:nth-child(6) {
    -webkit-animation: pacman-balls 1s 1.32s infinite linear;
            animation: pacman-balls 1s 1.32s infinite linear; }
  .pacman > div:nth-child(7) {
    -webkit-animation: pacman-balls 1s 1.65s infinite linear;
            animation: pacman-balls 1s 1.65s infinite linear; }
  .pacman > div:first-of-type {
    width: 0px;
    height: 0px;
    border-right: 25px solid transparent;
    border-top: 25px solid #a1b2c2;
    border-left: 25px solid #a1b2c2;
    border-bottom: 25px solid #a1b2c2;
    border-radius: 25px;
    -webkit-animation: rotate_pacman_half_up 0.5s 0s infinite;
            animation: rotate_pacman_half_up 0.5s 0s infinite; }
  .pacman > div:nth-child(2) {
    width: 0px;
    height: 0px;
    border-right: 25px solid transparent;
    border-top: 25px solid #a1b2c2;
    border-left: 25px solid #a1b2c2;
    border-bottom: 25px solid #a1b2c2;
    border-radius: 25px;
    -webkit-animation: rotate_pacman_half_down 0.5s 0s infinite;
            animation: rotate_pacman_half_down 0.5s 0s infinite;
    margin-top: -50px; }
  .pacman > div:nth-child(3), .pacman > div:nth-child(4), .pacman > div:nth-child(5), .pacman > div:nth-child(6), .pacman > div:nth-child(7) {
    background-color: #a1b2c2;
    width: 15px;
    height: 15px;
    border-radius: 100%;
    margin: 2px;
    width: 10px;
    height: 10px;
    position: absolute;
    -webkit-transform: translate(0, -6.25px);
        -ms-transform: translate(0, -6.25px);
            transform: translate(0, -6.25px);
    top: 25px;
    left: 100px; }

</style>



// WEBPACK FOOTER //
// components/Cc-Loading/loading.vue